<template>
    <div class="table">
        <div class="params-form">
            <a-form-model ref="searchForm" layout="inline" :model="formState">
                <!--④查询条件字段名+组件+提示文字+请输入提示文字-->
                <a-form-model-item label="专家姓名" prop="name">
                    <a-input v-model="formState.name"></a-input>
                </a-form-model-item>
                <a-form-model-item label="工作单位" prop="gov">
                    <a-input v-model="formState.gov"></a-input>
                </a-form-model-item>
                <a-form-model-item label="联系电话" prop="tel">
                    <a-input v-model="formState.tel"></a-input>
                </a-form-model-item>
                <a-form-model-item label="身份证号码" prop="userCard">
                    <a-input v-model="formState.userCard"></a-input>
                </a-form-model-item>
                <a-form-model-item label="职称" prop="zhicheng">
                    <div style="display: inline-block;width: 150px">
                        <a-ext-local-dic-select dic-key="ZhiCheng" v-model="formState.zhicheng"></a-ext-local-dic-select>
                    </div>
                </a-form-model-item>
                <a-form-model-item>
                    <a-space>
                        <a-button @click="onResetSearch">重置</a-button>
                        <a-button type="primary" @click="onSearchPage">查询</a-button>
                      <a-button type="primary" @click="randomExpertHandle">双随机专家组</a-button>
                      <a-button type="primary" @click="randomRecords">双随机记录</a-button>
                    </a-space>
                </a-form-model-item>
            </a-form-model>
        </div>
        <div class="table-content">
            <div>
                <div class="title" style="width: 350px;display: inline-block">
                    专家库管理
                    <div v-if="selectedRowCount"
                         style="width: 150px;display: inline-block;line-height: 20px;color: darkorange">共选择{{selectedRowKeys.length}}条
                    </div>
                </div>

                <div class="btn" style="width: calc(100% - 350px);display: inline-block;text-align: right">
                    <a-space>
                        <a-button type="primary" @click="onAddProfessorModalOpen" style="margin-right: 10px">新增</a-button>
                        <a-button  type="primary" @click="downloadExcel"  style="margin-right: 10px">模版下载</a-button>
                        <a-button  type="primary" @click="choiceExcel"  style="margin-right: 10px">导入</a-button>
                    </a-space>
                </div>
            </div>


            <a-config-provider :locale="locale">
                <a-table
                        :data-source="dataSource"
                        :columns="columns"
                        :pagination="pagination"
                        :loading="loading"
                        row-key="id"
                        @change="onPageChange"
                        :scroll="{ y: 500 }"
                >
                    <template slot="caozuo" slot-scope="text, record">
                        <a-button type="link" @click="onAddProfessorModalOpen(record)">编辑</a-button>
                        <a-button type="link"  @click="onDelete(record)">删除</a-button>
                        <span v-if="record.status==='启用'&&record.loginId" style="color:red ;cursor: pointer;margin-left: 16px;margin-right: 16px" @click="tingyong(record)">停用</span>
                        <a-button v-else-if="record.loginId" type="link" @click="qiyong(record)">启用</a-button>
                    </template>
                </a-table>
            </a-config-provider>
        </div>
        <input type="file" style="display:none" ref="hiddenFileInput" @change="uploadFileChange" />
        <a ref="downbtn" style="display: none" :href="baseApi+'mvc/common-file/downloadById?id=professor'"></a>
        <add-professor-modal v-if="addProfessorModalVisable" :visible.sync="addProfessorModalVisable"
                             :param="addProfessorModalParam"
                             @addProfessorClose="onAddProfessorModalClose"></add-professor-modal>
        <!--  双随机专家组    -->
        <a-modal
          title="双随机专家组"
          okText="确认"
          cancelText="取消"
          width="1000px"
          :visible="visible"
          @ok="handleOk"
          @cancel="visible=false"
      >
        <div class="outStyle">
          <a-table :data-source="dataSource2" :columns="columnsDig" :loading="randomLoading" :scroll="{ y: 500,x:'100%' }" :pagination="false" bordered>
            <template slot="caozuo" slot-scope="text, record">
              <a>{{ text }}</a>
            </template>
          </a-table>
          <a-button v-if="this.dataSource2.length>0" type="link" class="leaderStyle" @click="radomLeader">随机组长</a-button>
          <a-button v-if="this.dataSource2.length>0"  type="link" class="numberStyle" @click="radomNumber">随机组员</a-button>
          <a-button v-if="dataSource2.length>=4" type="link" class="delNumberStyle" @click="delNumber">删除</a-button>
        </div>
        <div class="addNumber">
          <a-button type="primary" icon="plus" @click="addGroupNumber">新增组员</a-button>
        </div>
      </a-modal>
        <!--  双随机记录    -->
        <a-modal
          title="双随机记录"
          okText="确认"
          cancelText=""
          width="1000px"
          :visible="recordVisible"
          :footer="false"
          @cancel="recordVisible=false"
      >
        <div class="outStyle">
          <a-table :data-source="dataSource3" :columns="columnsDig2" :pagination="false" bordered>
            <template slot="caozuo" slot-scope="text, record">
              <a>{{ text }}</a>
            </template>
          </a-table>
        </div>
        <div class="addNumber">
          <a-button type="primary" @click="recordVisible=false">确定</a-button>
        </div>
      </a-modal>
    </div>
</template>

<script>
    import axios from '@/api/request';
    //分页查询接口  ①分页查询SQL
    import {
      getProfessorPage as getPage,
      uploadProfessor,
      getAllNew,
      randomLeaderAndNumber,
      saveRecords,
      getRecordList
    } from '../../../api/api'
    import {delProfessorSelected as delPage,addorUpdateProfessor as updateApi,addorUpdateProfessor2} from '../../../api/api'
    //各个字段  ③查询条件选择组件
    import AExtLocalDicSelect from '../../../components/AntDesignExt/All/AExtLocalDicSelect'

    import AddProfessorModal from './AddProfessorModal'

    import _ from 'lodash'
    import ExportJsonExcel from "js-export-excel"
    import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
    import moment from "moment";

    export default {
        //各个字段  ⑤查询条件选择组件
        components: {
            AExtLocalDicSelect, AddProfessorModal,
        },
        data() {
            return {
                moment,
                randomLoading:false,
                dataSource2: [],
                dataSource3: [],
                columnsDig:[
                  {
                    title: '角色',
                    dataIndex: 'type',
                    key:'type',
                    width:'100px'
                  },
                  {
                    title: '姓名',
                    dataIndex: 'name',
                    key:'name',
                    width:'100px'
                  },
                  {
                    title: '职称',
                    dataIndex: 'zhicheng',
                    key:'zhicheng',
                    width:'120px',
                    ellipsis: true,
                  },
                  {
                    title: '单位',
                    dataIndex: 'gov',
                    key:'gov',
                    width:'150px',
                    ellipsis: true,
                  },
                  {
                    title: '电话',
                    dataIndex: 'tel',
                    key:'tel',
                    width:'150px'
                  },
                  {
                    title: '证书编号',
                    dataIndex: 'certificateNumber',
                    key:'certificateNumber',
                    width:'150px',
                    ellipsis: true,
                  },
                  {
                    title: '证书有效期',
                    dataIndex: 'certificateExpirationDate',
                    key:'certificateExpirationDate',
                    width:'150px',
                    ellipsis: true,
                  },
                  {
                    title: '所在地',
                    dataIndex: 'address',
                    key:'address',
                    width:'150px',
                    ellipsis: true,
                  },
                  {
                    title: '操作',
                    width:'100px',
                    fixed: 'right',
                    customRender: (value, row, index) => {
                      const obj = {
                        children: value,
                        attrs: {},
                      };
                      if (index === 1) {
                        obj.attrs.rowSpan = 3;
                      }
                      // These two are merged into above cell
                      if (index === 3) {
                        obj.attrs.rowSpan = 0;
                      }
                      if (index === 2) {
                        obj.attrs.rowSpan = 0;
                      }
                      return obj;
                    },
                  },
                ],
                columnsDig2:[
                {
                  title: '日期',
                  dataIndex: 'time',
                  key:'time'
                },
                {
                  title: '专家组组长',
                  dataIndex: 'leader',
                  key:'leader'
                },
                {
                  title: '专家组组员1',
                  dataIndex: 'member1',
                  key:'member1'
                },
                {
                  title: '专家组组员2',
                  dataIndex: 'member2',
                  key:'member2'
                },
                {
                  title: '专家组组员3',
                  dataIndex: 'member3',
                  key:'member3'
                },
              ],
                visible:false,
                recordVisible:false,
                locale: zhCN,
                baseApi:window.BASE_CONFIG.VUE_APP_BASE_API,
                formState: {
                    //②查询条件字段名
                    name: ''
                },
                params: {},
                // 表头
                columns: [
                    {
                        title: "序号",
                        dataIndex: "index",
                        width: "80px",
                        align:'center'
                    },
                    {
                        title: "专家姓名",
                        dataIndex: "name",
                        width: "100px",
                        align:'center',
                        ellipsis: true,
                    },
                  {
                    title: "职称",
                    dataIndex: "zhicheng",
                    width: "100px",
                    align:'center',
                    ellipsis: true,
                  },
                    /*{
                        title: "性别",
                        dataIndex: "sex",
                        width: "100px",
                        align:'center',
                        ellipsis: true,
                    },*/
                    {
                        title: "工作单位",
                        dataIndex: "gov",
                        width: "100px",
                        align:'center',
                        ellipsis: true,
                    },
                    /*{
                        title: "现从事专业",
                        dataIndex: "zhuanye",
                        width: "100px",
                        align:'center',
                        ellipsis: true,
                    },*/


                    {
                        title: "电话",
                        dataIndex: "tel",
                        width: "100px",
                        align:'center',
                        ellipsis: true,
                    },
                    /*{
                        title: "邮箱",
                        dataIndex: "mail",
                        width: "100px",
                        align:'center',
                        ellipsis: true,
                    },*/
                    {
                        title: "所在地",
                        dataIndex: "address",
                        width: "100px",
                        align:'center',
                        ellipsis: true,
                    },
                  {
                    title: "角色",
                    dataIndex: "type",
                    width: "100px",
                    align:'center',
                    ellipsis: true,
                  },
                    /*{
                        title: "身份证号码",
                        dataIndex: "userCard",
                        width: "100px",
                        align:'center',
                        ellipsis: true,
                    },*/
                    {
                        title: "操作",
                        dataIndex: "id",
                        width: "200px",
                        align:'center',
                        ellipsis: true,
                        scopedSlots: {customRender: "caozuo"},
                    },
                ],
                // 表格数据
                dataSource: [],
                // 选中的行
                selectedRowKeys: [],
                selectedRows: [],
                loading: false,
                // 分页器
                pagination: {
                    total: 0,
                    current: 1,
                    pageSize: 10,
                    pageSizeOptions: ["10", "15", "35", "45"],
                    showSizeChanger: true,showQuickJumper:true,
                    size: "small",
                    showTotal: total => `共${total}条记录 `
                },
                addProfessorModalVisable: false,
                addProfessorModalBackChange: null,
                addProfessorModalParam: null
            };
        },
        mounted() {
            this.onSearchPage();
        },
        computed: {
            selectedRowCount() {
                return this.selectedRowKeys.length;
            }
        },
        methods: {
          // 新增组员
          addGroupNumber(){
            console.log(this.dataSource2.length,"124")
            if(this.dataSource2.length<4){
              const id = this.dataSource2.filter(item=>item.type==='组长')[0].id
              let data = {
                id,
                size:1,
                type:2
              }
              randomLeaderAndNumber(data).then(res=>{
                if(res.data.code===1){
                  const index = this.dataSource2.findIndex(item=>item.name===res.data.data[0].name)
                  if(index===-1){
                    this.$message.success("新增成功")
                    this.dataSource2.push(res.data.data[0])
                  }
                }
              })
            } else {
              this.$message.warn('组员不能超过3个人')
            }
          },
          radomLeader(){
            const list = this.dataSource2.filter(item=>item.type==='组员')
            const listVal = list&&list.length>0?list.map(item=>item.id):[]
            this.randomArrHandle(listVal.toString(),0,1)
          },
          radomNumber(){
            const val = this.dataSource2.filter(item=>item.type==='组长')[0].id
            const numbers = this.dataSource2.filter(item=>item.type==='组员')
            this.randomArrHandle(val,numbers.length,2)
          },
          delNumber(){
            this.dataSource2.pop()
          },
          renderCell(text, record, index) {
            // 判断是否需要进行单元格合并
            if (index > 0 && record.address === this.dataSource[index - 1].address) {
              return {
                children: text,
                attrs: {
                  rowSpan: 0 // 合并单元格
                }
              }
            }
            const rows = this.getRowsNumber(record.address)
            return {
              children: text,
              attrs: {
                rowSpan: rows // 每一行合并的单元格数
              }
            }
          },
          getRowsNumber(address) {
            // 计算每个地址有多少行需要进行合并
            let count = 1
            this.dataSource.forEach(item => {
              if (item.address === address) {
                count++
              }
            })
            return count
          },
            // 确定随机
            handleOk(){
              const params = {
                leader:this.dataSource2.filter(item=>item.type==='组长')[0].name
              }
              const arr = this.dataSource2.filter(item=>item.type==='组员')
              if(arr&&arr.length>0){
                arr.forEach((item,index)=>{
                  params['member'+(index+1)] = item.name
                })
              }
              saveRecords(params).then(res=>{
                    if(res.data.code===1){
                      this.$message.success("保存成功")
                      this.visible = false
                    }
              })
            },
            // 查询随机记录
            getRecordListHandle(){
              getRecordList().then(res=>{
                if(res.data.code===1&&res.data.data.length>0){
                  let arr = []
                  res.data.data.forEach(item=>{
                    arr.push({
                      ...item,
                      time:moment(item.createdAt).format("YYYY-MM-DD HH:mm:ss")
                    })
                  })
                  this.dataSource3 = arr
                  console.log(arr,"this.dataSource3")
                  this.recordVisible = true
                }
              })
            },
            // 双随机专家组
            randomExpertHandle(){
              this.visible = true
              this.randomArrHandle("",2,0)
            },
            // 随机数组
            randomArrHandle(id,size,type){
              let data = {
                id,
                size,
                type
              }
              this.randomLoading = true
              randomLeaderAndNumber(data).then(res=>{
                if(res.data.code===1){
                  if(type===0){
                    this.randomLoading = false
                    this.dataSource2 = res.data.data
                  } else {
                    if(type===1){
                      const numberList =  this.dataSource2.filter((item=>item.type==='组员'))
                      this.dataSource2 = [...res.data.data,...numberList]
                    } else if(type===2){
                      const numberList =  this.dataSource2.filter((item=>item.type==='组长'))
                      this.dataSource2 = [...numberList,...res.data.data]
                    }
                    setTimeout(()=>{
                      this.randomLoading = false
                    },1000)
                  }
                }
              }).catch(()=>{
                this.randomLoading = false
              })
            },
            // 双随机记录
            randomRecords(){
              this.getRecordListHandle()
            },
            // 查询
            onSearchPage() {
                this.selectedRowKeys = [];
                this.selectedRows = [];
                this.pagination.current = 1;
                this.params = {
                    pageSize: this.pagination.pageSize,
                    current: this.pagination.current,
                    ...this.formState,
                };
                this.getData(this.params);
            },
            //重置
            onResetSearch() {
                this.$refs.searchForm.resetFields();
                this.onSearchPage()
            },
            // 翻页
            onPageChange(pagination, filters, sorter) {
                this.pagination = pagination;
                this.params.pageSize = pagination.pageSize;
                this.params.current = pagination.current;
                this.getData(this.params);
            },
            // 请求接口查询数据
            getData(params) {
                this.loading = true;
                params.dataRegion=(this.$store.state.user.dataJurisdiction==='2'||this.$store.state.user.dataJurisdiction==='3')?this.$store.state.user.address.region.code:'320000';
                params.creator=this.$store.state.user.dataJurisdiction==='3'?this.$store.state.user.id:'';
                getPage(params).then(result => {
                    this.pagination.total = result.data.data.total;
                    this.pagination.current = result.data.data.current;
                    this.pagination.pageSize = result.data.data.size;
                    this.dataSource = result.data.data.records.map((item, index) => {
                        item.index = index + 1
                        return item
                    });
                    this.loading = false;
                }).catch(() => {
                    this.loading = false;
                })
            },
            // 复选框变化
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
                let removedItems = [];
                let addItems = [];
                this.selectedRows.forEach(oldSelectedItem => {
                    if (!selectedRowKeys.includes(oldSelectedItem.id)) {
                        removedItems.push(oldSelectedItem);
                    }
                });
                this.selectedRowKeys.forEach(newKey => {
                    let find = false;
                    this.selectedRows.forEach(oldSelectedItem => {
                        if (oldSelectedItem.id === newKey) {
                            find = true;
                        }
                    });
                    if (!find) {
                        this.dataSource.forEach(thisPageItem => {
                            if (thisPageItem.id === newKey) {
                                addItems.push(thisPageItem);
                            }
                        })
                    }
                });
                removedItems.forEach(row => {
                    this.selectedRows.remove(row)
                });
                this.selectedRows = this.selectedRows.concat(addItems)
            },
            onDelete(record) {
                let myGetData=this.getData;
                let myParam=this.params;
                let that=this;
                let enableU=this.enableUser;
                let loginId=record.loginId;
                this.$confirm({
                    title: '是否删除数据?',
                    content: '确认后数据将永久删除，是否确认？',
                    okText: '确认',
                    okType: 'danger',
                    cancelText: '取消',
                    onOk() {
                        delPage(record.id).then(() => {
                            try
                            {
                                enableU(loginId,'禁用');
                            }
                            catch (e) {

                            }
                            myGetData(myParam)
                        }).catch(err => {
                            that.$message.error(err.message);
                        });
                    },
                    onCancel() {
                        console.log('Cancel');
                    },
                });
            },

            onAddProfessorModalOpen(record) {
                this.addProfessorModalParam = {id: record.id};
                this.addProfessorModalVisable = true;
                //TODO: 无
            },
            onAddProfessorModalClose() {
                this.getData(this.params)
            },
            // 批量删除
            onBatchDelete() {
                if (this.selectedRowKeys.length === 0) {
                    this.$message.error('请选择要删除的数据');
                    return
                }
                let keys = this.selectedRowKeys;
                let funcOK = () => {
                    delPage(_.join(keys, ',')).then(() => {
                        this.selectedRowKeys = [];
                        this.selectedRows = [];
                        this.getData(this.params);
                    }).catch(err => {
                        this.$message.error(err.message);
                    });
                }
                this.$confirm({
                    title: '是否删除数据?',
                    content: '确认后数据将永久删除，是否确认？',
                    okText: '确认',
                    okType: 'danger',
                    cancelText: '取消',
                    onOk() {
                        funcOK();
                    },
                    onCancel() {
                        console.log('Cancel');
                    },
                });
            },
            // 导出excel
            // 导出excel
            onExportExcel() {
                if (this.selectedRowKeys.length == 0) {
                    this.$message.error('请选择要导出的数据');
                    return
                }
                let sheetColHeader=[];
                let sheetColFilter=[];
                this.columns.forEach(col=>{
                    if(col.title !== '操作') {
                        sheetColFilter.push(col.dataIndex)
                        sheetColHeader.push(col.title)
                    }
                });
                let exportRows=[];
                let i=0;
                this.selectedRows.forEach(item=>{
                    i++;
                    let newItem=_.cloneDeep(item);
                    newItem.index=i.toString();
                    exportRows.push(newItem)
                });
                let option = {};
                option.fileName = "数据导出";
                option.datas = [
                    {
                        sheetData: exportRows,
                        sheetName: "数据导出",
                        sheetFilter: sheetColFilter,
                        sheetHeader: sheetColHeader,
                        columnWidths: [],
                    },
                ];

                var toExcel = new ExportJsonExcel(option); //new
                toExcel.saveExcel();
            },
            qiyong(record)
            {
                let funcOK = () => {
                    updateApi({id:record.id,status:'启用'}).then(() => {
                        this.enableUser(record.loginId,'启用');
                        this.getData(this.params);
                    }).catch(err => {
                        this.$message.error(err.message);
                    });
                }
                this.$confirm({
                    title: '确认启用?',
                    content: '启用后该专家可以进行分配？',
                    okText: '确认',
                    okType: 'danger',
                    cancelText: '取消',
                    onOk() {
                        funcOK()
                    },
                    onCancel() {
                        console.log('Cancel');
                    },
                });
            },
            tingyong(record)
            {
                let funcOK = () => {
                    updateApi({id:record.id,status:'禁用'}).then(() => {
                        try {
                            this.enableUser(record.loginId, '禁用');
                        }catch (e) {

                        }
                        this.getData(this.params);
                    }).catch(err => {
                        this.$message.error(err.message);
                    });
                }
                this.$confirm({
                    title: '确认禁用?',
                    content: '禁用后该专家将无法进行分配？',
                    okText: '确认',
                    okType: 'danger',
                    cancelText: '取消',
                    onOk() {
                        funcOK()
                    },
                    onCancel() {
                        console.log('Cancel');
                    },
                });
            },
            downloadExcel(){
                this.$refs.downbtn.dispatchEvent(new MouseEvent('click'))
            },
            choiceExcel() {
                this.$refs.hiddenFileInput.dispatchEvent(new MouseEvent('click'))
            },
            uploadFileChange(){
                if(this.$refs.hiddenFileInput.files[0].name.toLowerCase().indexOf('.xls')===-1
                    &&this.$refs.hiddenFileInput.files[0].name.toLowerCase().indexOf('.xlsx')===-1)
                {
                    this.$message.warn('仅允许上传Excel文件，请将文件先转换为Excel再进行上传!');
                    return;
                }
                let objs=[];
                this.loading=true;
                try {
                    uploadProfessor({
                        regionCode: this.$store.state.user.address.region.code,
                        file: this.$refs.hiddenFileInput.files[0]
                    }).then(result => {
                        if (result.data && result.data.succ && result.data.data === '成功') {
                            getAllNew().then(res => {
                                if (res.data.data) {
                                    objs = res.data.data;
                                    objs.forEach(obj => {
                                        let user = {
                                            confirmPassword: obj.pwd,
                                            idCardNo: obj.userCard,
                                            name: obj.name,
                                            password: obj.pwd,
                                            phone: obj.tel,
                                            regionCode: obj.regionCode,
                                            roleId: '1648951568536907777',
                                            // roleId: '1560473889248219138',
                                            username: obj.account
                                        };
                                        this.addUser(user).then(res1 => {
                                            if(res1.data.data) {
                                                this.enableUser(res1.data.data, '启用');
                                                obj.loginId = res1.data.data;
                                                obj.succ = true;
                                            }
                                            else
                                            {
                                                obj.msg=res1.data.msg;
                                                obj.succ=false;
                                            }
                                        }).catch(ex => {
                                            obj.msg='创建账号时'+ex.data.msg;
                                            obj.succ = false;
                                        })
                                    })
                                }
                            });
                            this.$refs.hiddenFileInput.value = '';
                        }
                        else {
                            this.loading=false
                            this.$refs.hiddenFileInput.value = '';
                            this.$message.error(result.data.data)
                        }
                    }).catch(() => {
                        this.$refs.hiddenFileInput.value = '';
                    })
                }
                catch (e) {
                    this.$refs.hiddenFileInput.value = '';
                }
                setTimeout(()=>{
                    let failedList=[];
                    let okList=[];
                    if(!objs.length)
                    {
                        return;
                    }
                    objs.forEach(obj => {
                        if (!obj.succ) {
                            failedList.push(obj);
                            delPage(obj.id);
                        }
                        else {
                            okList.push(obj);
                            addorUpdateProfessor2(obj);
                        }
                    });
                    this.loading=false;


                    if(failedList.length>0) {
                        if(okList.length===0){

                            this.$message.error('导入失败');
                        }
                        else {
                            this.$message.warn('导入完成，成功导入' + okList.length + '条，失败' + failedList.length + '条');
                        }
                        this.exportFail(failedList);
                    }
                    else
                    {
                        if(okList.length===0){
                            this.$message.error('导入失败');
                        }
                        else {
                            this.$message.success('导入成功！');
                        }
                    }
                    this.getData(this.params)
                },9000)
            },
            exportFail(arr){
                let sheetColHeader=['姓名','性别','工作单位','现从事专业','职称','职务','电话','邮箱','地址','身份证号码','账号','密码','错误信息'];
                let sheetColFilter=['name','sex','gov','zhuanye','zhicheng','zhiwu','tel','mail','address','userCard','account','pwd','msg'];

                let exportRows=arr;
                let option = {};
                option.fileName = "未导入成功的数据";
                option.datas = [
                    {
                        sheetData: exportRows,
                        sheetName: "未导入成功的数据",
                        sheetFilter: sheetColFilter,
                        sheetHeader: sheetColHeader,
                        columnWidths: [],
                    },
                ];

                var toExcel = new ExportJsonExcel(option); //new
                toExcel.saveExcel();
            },
            success() {
                this.$message.success(
                    '操作成功',
                    2,
                );
            },
            addUser(user) {
                const username = user.username.trim();
                return new Promise((resolve, reject) => {
                    axios({
                        url: window.BASE_CONFIG.USER_API+'api/v1/user/saveUser',
                        method: 'post',
                        data: user,
                    })
                        .then((res) => {
                            resolve(res);
                        })
                        .catch((e) => {
                            reject(e);
                        });
                });
            },
            enableUser(userId,isEnable){
                let stat='enable';
                if(isEnable==='禁用')
                {
                    stat='ban'
                }

                axios({
                    url: window.BASE_CONFIG.USER_API+'api/v1/user/updateBatchById',
                    method: 'post',
                    data: {userIds:[userId],operationType: stat},
                })
                    .then((res) => {
                        console.log('修改状态',res)
                    })
                    .catch((e) => {
                        this.$message.warn('用户添加成功，但启用失败！');
                    });
            }
        },
    };
</script>
<style lang="scss" scoped>
    .table {
        .params-form {
            margin: 16px;
            height: 64px;
            display: flex;
            -webkit-box-align: center;
            align-items: center;
            -webkit-box-pack: justify;
            justify-content: space-between;
            border-radius: 8px;
            background-color: rgb(255, 255, 255);
            box-shadow: #1b2f7017 0px 2px 4px 2px;
            padding: 0px 16px;
        }
        .table-content {
            margin: 16px;
            padding: 20px 24px;
            box-shadow: #1b2f7017 0px 2px 4px 2px;
            background-color: rgb(255, 255, 255);
            border-radius: 8px;
            overflow-y: hidden;
            .title {
                padding-left: 12px;
                font-size: 16px;
                font-weight: 500;
                line-height: 1;
                color: rgba(0, 0, 0, 0.85);
                position: relative;
                margin-bottom: 16px;
                display: flex;
                -webkit-box-pack: justify;
                justify-content: space-between;
                -webkit-box-align: center;
                align-items: center;
            }
            .title::before {
                content: '';
                position: absolute;
                height: 16px;
                top: calc(50% - 8px);
                left: 0px;
                width: 3px;
                background-color: rgb(36, 113, 210);
            }

            .btn {
                padding-bottom: 15px;
                display: flex;
                justify-content: end;
            }

            /deep/ .ant-table-wrapper {
                .ant-table {
                    border-top: 1px solid rgba(15, 41, 61, 0.45);
                    border-bottom: 1px solid rgba(15, 41, 61, 0.45);
                    border-image: initial;
                    border-left: none;
                    border-right: none;
                }
                .ant-table-thead {
                    background: #fafafa;
                }
                .ant-table-thead > tr > th {
                    font-weight: 500;
                    line-height: 1;
                    color: rgba(21, 40, 77, 0.65);
                    background-color: rgb(245, 250, 255);
                }
            }
        }
    }
    .outStyle{
      position: relative;
      padding-right:60px;
      .leaderStyle{
        position: absolute;
        right: 65px;
        top: 66px;
        z-index: 10000;
      }
      .numberStyle{
        position: absolute;
        right: 65px;
        top: 160px;
        z-index: 10000;
      }
      .delNumberStyle{
        position: absolute;
        right: 5px;
        top: 227px;
        z-index: 10000;
      }
    }
    .addNumber{
      margin-top: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
</style>
